
  const TOTAL_STEPS = 9;
  const STORAGE_KEY = 'thepetails_wizard_v2';
  const STORAGE_TTL = 30 * 24 * 60 * 60 * 1000;
  let currentStep = 1;
  const data = {
    photos: [],
    name: '', species: '', breed: '', age: '', weight: '', color: '', gender: '',
    energy: '', social: '', traits: [], essence: '', signature: '', monologue: '',
    feeding: '', treats: '', activities: [], sleep: '', quirks: '',
    city: '', zip: '', home: '', squad: [], humans: '', weekend: [],
    enemies: '', iconic: '', mishaps: '', companions: '', oneThingToKnow: '',
    vibe: '', creativeDirection: '',
    ownerName: '', ownerEmail: '', occasion: '', source: '', newsletter: true
  };

  function saveProgress() {
    try {
      const toSave = { ...data, photos: [] };
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ data: toSave, step: currentStep, timestamp: Date.now() }));
    } catch (e) { console.warn('Could not save progress', e); }
  }

  function loadProgress() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.timestamp > STORAGE_TTL) { localStorage.removeItem(STORAGE_KEY); return false; }
      const keepPhotos = data.photos;
      Object.assign(data, parsed.data);
      data.photos = keepPhotos;
      return parsed.step || 1;
    } catch (e) { return false; }
  }

  function clearProgress() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  function restoreFormUI() {
    const fieldMap = {
      'pet-name': 'name', 'pet-breed': 'breed', 'pet-age': 'age', 'pet-color': 'color',
      'pet-essence': 'essence', 'pet-signature': 'signature', 'pet-monologue': 'monologue',
      'pet-treats': 'treats', 'pet-quirks': 'quirks', 'city': 'city',
      'pet-enemies': 'enemies', 'pet-iconic': 'iconic', 'pet-mishaps': 'mishaps',
      'pet-companions': 'companions', 'owner-name': 'ownerName', 'owner-email': 'ownerEmail',
      'pet-creative': 'creativeDirection'
    };
    Object.entries(fieldMap).forEach(([id, key]) => { const el = document.getElementById(id); if (el && data[key]) el.value = data[key]; });
    const singleGroups = [['species-chips','species'],['weight-chips','weight'],['energy-chips','energy'],['social-chips','social'],['feeding-chips','feeding'],['sleep-chips','sleep'],['home-chips','home'],['humans-chips','humans'],['occasion-chips','occasion'],['source-chips','source']];
    singleGroups.forEach(([container, key]) => { if (data[key]) { const chip = document.querySelector(`#${container} .chip[data-val="${data[key]}"]`); if (chip) chip.classList.add('active'); } });
    if (data.gender) { const chip = document.querySelector(`[data-group="gender"][data-val="${data.gender}"]`); if (chip) chip.classList.add('active'); }
    const multiGroups = [['traits-chips','traits'],['activity-chips','activities'],['squad-chips','squad'],['weekend-chips','weekend']];
    multiGroups.forEach(([container, key]) => { if (Array.isArray(data[key])) { data[key].forEach(val => { const chip = document.querySelector(`#${container} .chip[data-val="${val}"]`); if (chip) chip.classList.add('active'); }); } });
    if (data.vibe) { const card = document.querySelector(`#wizard-vibes .vibe-card[data-vibe="${data.vibe}"]`); if (card) card.classList.add('selected'); }
    const newsCheck = document.getElementById('news-check');
    if (newsCheck) { if (data.newsletter) newsCheck.classList.add('on'); else newsCheck.classList.remove('on'); }
  }

  function setIntroChrome(introMode) {
    const prog = document.getElementById('wizard-progress');
    if (prog) prog.style.visibility = introMode ? 'hidden' : 'visible';
    const navWrap = document.getElementById('wizard-nav');
    if (navWrap) navWrap.style.display = introMode ? 'none' : 'flex';
  }


  function openWizard() {
    const intro = document.getElementById('wizard-intro');
    const savedStep = loadProgress();
    if (savedStep) {
      if (intro) intro.classList.add('hidden');
      setIntroChrome(false);
      restoreFormUI();
      currentStep = savedStep;
      showStep(currentStep);
    } else {
      if (intro) intro.classList.remove('hidden');
      document.querySelectorAll('.step').forEach(s => s.classList.add('hidden'));
      setIntroChrome(true);
    }
    document.getElementById('wizard').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function startWizard() {
    const intro = document.getElementById('wizard-intro');
    if (intro) intro.classList.add('hidden');
    setIntroChrome(false);
    currentStep = 1;
    showStep(1);
  }

  function closeWizard() {
    document.getElementById('wizard').classList.remove('open');
    document.body.style.overflow = '';
  }

  function showStep(n) {
    clearWizardError();
    document.querySelectorAll('.step').forEach(s => s.classList.add('hidden'));
    const target = document.querySelector(`.step[data-step="${n}"]`);
    if (target) target.classList.remove('hidden');
    const pct = Math.min(100, Math.round(n / TOTAL_STEPS * 100));
    document.getElementById('progress-fill').style.width = pct + '%';
    var pp = document.getElementById('progress-pet');
    if (pp) {
      pp.style.left = pct + '%';
      pp.textContent = petEmoji();
      pp.classList.remove('run'); void pp.offsetWidth; pp.classList.add('run');
      setTimeout(function(){ pp.classList.remove('run'); }, 850);
    }
    document.querySelectorAll('.pf-nm').forEach(function(s){
      s.textContent = data.name ? (s.dataset.form === 'full' ? data.name : data.name + "'s") : s.dataset.default;
    });
    document.getElementById('step-label').textContent = n > TOTAL_STEPS ? 'Done!' : `Chapter ${n} of ${TOTAL_STEPS}`;
    document.getElementById('wizard-nav').style.display = n > TOTAL_STEPS ? 'none' : 'flex';
    document.getElementById('back-btn').style.visibility = n === 1 ? 'hidden' : 'visible';
    document.getElementById('next-btn').textContent = n === TOTAL_STEPS ? 'Send my story ✦' : 'Next →';
    document.querySelector('.modal').scrollTop = 0;
  }

  // ── Celebration engine (Duolingo-style micro-rewards) ──
  var PET_EMOJI={dog:'🐶',cat:'🐱',rabbit:'🐰',bird:'🦜',horse:'🐴',reptile:'🦎',other:'✨'};
  var VIBE_LABEL={comic:'Comic Caper',storybook:'Storybook Magic',movie:'Cinema Poster',heritage:'Heritage Edition',pixar:'Pixar Magic'};
  function petEmoji(){ return PET_EMOJI[data.species]||'🐾'; }
  var celTimer=null, celNext=null;
  function celebrate(o, then){
    var el=document.getElementById('pf-cel');
    celNext=then||null;
    var ph=document.getElementById('pf-cel-photo'), em=document.getElementById('pf-cel-emoji');
    if(o.photo){ ph.src=o.photo; ph.style.display='block'; em.style.display='none'; }
    else { ph.style.display='none'; em.style.display='block'; em.textContent=o.emoji||petEmoji(); }
    document.getElementById('pf-cel-title').textContent=o.title;
    document.getElementById('pf-cel-sub').textContent=o.sub||'';
    el.style.display='flex';
    requestAnimationFrame(function(){ el.classList.add('show'); });
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      for(var i=0;i<12;i++){
        var s=document.createElement('span'); s.className='pf-paw';
        s.textContent=['🐾','✦','⭐'][i%3];
        s.style.left=(5+Math.random()*90)+'%';
        s.style.animationDuration=(1+Math.random()*0.9)+'s';
        s.style.animationDelay=(Math.random()*0.25)+'s';
        el.appendChild(s);
        setTimeout((function(x){return function(){x.remove();};})(s),2400);
      }
    }
    clearTimeout(celTimer);
    celTimer=setTimeout(closeCelebrate, o.ms||1300);
  }
  function closeCelebrate(){
    var el=document.getElementById('pf-cel');
    clearTimeout(celTimer);
    el.classList.remove('show');
    setTimeout(function(){ el.style.display='none'; var f=celNext; celNext=null; if(f)f(); },180);
  }

  // ★ UPDATED: celebrations between steps; product picker on step 8
  function nextStep() {
    if (!validateStep(currentStep)) return;
    saveStep(currentStep);
    saveProgress();
    var n = data.name || 'your star';
    if (currentStep === 1) {
      var ph = (data.photos[0] && data.photos[0].dataUrl) || null;
      celebrate({ title:'A star is born ✦', sub:'Great photos. Now let\'s build the legend.', photo:ph, ms:2000 }, showNotice);
      return;
    }
    if (currentStep === TOTAL_STEPS) {
      currentStep = 10;
      showStep(10);
      return;
    }
    var cel=null;
    if(currentStep===2) cel={ title:'Meet '+n+' ✦', sub:'The star has a name. Chapter one: done.', ms:1800 };
    if(currentStep===3) cel={ title:n+"'s personality: unlocked 🎭", ms:1100 };
    if(currentStep===4) cel={ title:'Halfway there ⭐', sub:n+"'s world is taking shape.", ms:1100 };
    if(currentStep===6) cel={ title:'The lore is legendary 📖', sub:'Our writers are going to feast.', ms:1400 };
    if(currentStep===7) cel={ title:n+' × '+(VIBE_LABEL[data.vibe]||'their universe')+' ✦', sub:'Iconic choice.', ms:1100 };
    currentStep++;
    if(cel){ celebrate(cel, function(){ showStep(currentStep); saveProgress(); }); }
    else { showStep(currentStep); saveProgress(); }
  }

  function showNotice() {
    document.querySelectorAll('.step').forEach(s => s.classList.add('hidden'));
    document.getElementById('wizard-notice').classList.remove('hidden');
    setIntroChrome(true);
  }

  function continueFromNotice() {
    document.getElementById('wizard-notice').classList.add('hidden');
    setIntroChrome(false);
    currentStep = 2;
    showStep(2);
    saveProgress();
  }

  // ── Hardened submission: timeouts, retries, live progress, no silent failures ──
  const UPLOAD_TIMEOUT_MS = 30000;   // per attempt, per photo
  const META_TIMEOUT_MS   = 25000;
  const UPLOAD_ATTEMPTS    = 4;
  const META_ATTEMPTS      = 4;
  let isSubmitting = false;
  let pendingProductUrl = null;

  function fetchWithTimeout(url, options, ms) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), ms);
    return fetch(url, Object.assign({}, options, { signal: ctrl.signal })).finally(() => clearTimeout(timer));
  }

  function upStatus(msg) { const el = document.getElementById('pf-up-status'); if (el) el.textContent = msg; }
  function upProgress(done, total) { const bar = document.getElementById('pf-up-bar'); if (bar) bar.style.width = Math.round((Math.max(0, done) / Math.max(1, total)) * 100) + '%'; }
  function showUploadView(view) {
    const w = document.getElementById('pf-up-working'), er = document.getElementById('pf-up-error');
    if (w)  w.style.display  = (view === 'working') ? '' : 'none';
    if (er) er.style.display = (view === 'error')   ? '' : 'none';
  }
  function showUpError(msg) { const el = document.getElementById('pf-up-errmsg'); if (el && msg) el.textContent = msg; showUploadView('error'); }

  function beforeUnloadGuard(e) { e.preventDefault(); e.returnValue = ''; return ''; }
  function setSubmitGuard(on) {
    if (on) window.addEventListener('beforeunload', beforeUnloadGuard);
    else window.removeEventListener('beforeunload', beforeUnloadGuard);
  }

  // Agrega los items al carrito vía AJAX (con submissionId como propiedad de línea)
  // y manda al checkout. Punto único: todo lo que pase por aquí queda enlazado al libro.
  async function goToCheckout(productUrl) {
    var sid = getSubmissionId();
    var spec = productUrl.replace(/^\/cart\//, '').split('?')[0];
    var items = spec.split(',').map(function (pair) {
      var p = pair.split(':');
      return { id: Number(p[0]), quantity: Number(p[1] || 1), properties: { submissionId: sid } };
    });
    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      window.location.href = '/checkout';
    } catch (e) {
      window.location.href = productUrl;
    }
  }

  async function selectProduct(productUrl) {
    if (isSubmitting) return;
    isSubmitting = true;
    pendingProductUrl = productUrl;
    setSubmitGuard(true);
    const nm = document.getElementById('confirm-name'); if (nm) nm.textContent = data.name || 'your beast';
    currentStep = 11;
    showStep(11);
    showUploadView('working');
    upStatus('Uploading your photos… keep this page open.');
    upProgress(data.photos.filter(p => p.uploadedUrl).length, data.photos.length || 1);

    let result;
    try { result = await finalizeSubmission(); }
    catch (e) { console.warn('finalizeSubmission threw:', e); result = { ok: false, reason: 'exception' }; }

    if (!result.ok) {
      isSubmitting = false;
      setSubmitGuard(false);
      if (result.reason === 'no-photos') {
        currentStep = 1; showStep(1);
        showWizardError('We need your photos again — please re-add them. Your other answers are saved. ✦');
        return;
      }
      showUpError('Your connection dropped before we could finish — but nothing you entered is lost. Stay on Wi-Fi if you can and tap Try again. ✦');
      return;
    }

    // success — confirm briefly, then hand off to checkout
    setSubmitGuard(false);
    clearProgress();
    console.log('🐾 Submission complete:', getSubmissionId(), '· photos:', result.photoCount, '· sheet notified:', result.notified);
    upStatus('Got it! Taking you to checkout…');
    upProgress(1, 1);
    setTimeout(function () { goToCheckout(productUrl); }, 900);
  }

  function retrySubmit() {
    if (isSubmitting || !pendingProductUrl) return;
    selectProduct(pendingProductUrl);
  }
  function restartFromError() {
    isSubmitting = false; setSubmitGuard(false);
    currentStep = 1; showStep(1);
  }

  function prevStep() {
    if (currentStep > 1) { currentStep--; showStep(currentStep); saveProgress(); }
  }

  function showWizardError(msg) {
    const el = document.getElementById('wizard-error');
    if (!el) return;
    el.textContent = msg;
    el.classList.remove('hidden');
  }

  function clearWizardError() {
    const el = document.getElementById('wizard-error');
    if (!el) return;
    el.classList.add('hidden');
    el.textContent = '';
  }

  function validateStep(step) {
    clearWizardError();
    const shake = (el) => { if (!el) return; el.classList.add('shake'); setTimeout(() => el.classList.remove('shake'), 400); };
    const reveal = (el) => { if (!el) return; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
    const txt = (id) => (document.getElementById(id)?.value || '').trim();
    const failInput = (id, msg) => { const el = document.getElementById(id); shake(el); reveal(el); if (el) setTimeout(() => { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }, 350); showWizardError(msg); return false; };
    const failChips = (containerId, msg) => { const el = document.getElementById(containerId); shake(el); reveal(el); showWizardError(msg); return false; };
    const failGender = (msg) => { const g = document.querySelector('[data-group="gender"]'); const box = g ? g.parentElement : null; shake(box); reveal(box); showWizardError(msg); return false; };
    if (step === 1) { if (data.photos.length === 0) { shake(document.getElementById('upload-zone')); reveal(document.getElementById('upload-zone')); showWizardError('Add at least one photo to start — the more you upload, the better the book ✦'); return false; } }
    if (step === 2) { if (!txt('pet-name')) return failInput('pet-name','Your star needs a name ✦'); if (!data.species) return failChips('species-chips','Pick their species ✦'); if (!txt('pet-breed')) return failInput('pet-breed','Breed or proud mutt — tell us ✦'); if (!txt('pet-age')) return failInput('pet-age','How old is the legend? ✦'); if (!data.weight) return failChips('weight-chips','Pick their size in the story ✦'); if (!txt('pet-color')) return failInput('pet-color','Their coat color or pattern ✦'); if (!data.gender) return failGender('Pick their pronouns ✦'); }
    if (step === 3) { if (!data.energy) return failChips('energy-chips','Pick their energy level ✦'); if (!data.social) return failChips('social-chips','How are they with strangers? ✦'); if (!data.traits || data.traits.length === 0) return failChips('traits-chips','Pick at least one personality trait ✦'); if (!txt('pet-essence')) return failInput('pet-essence','Sum them up in one sentence ✦'); if (!txt('pet-signature')) return failInput('pet-signature',"What's their signature move? ✦"); if (!txt('pet-monologue')) return failInput('pet-monologue','Give them a minute on the mic ✦'); }
    if (step === 4) { if (!data.feeding) return failChips('feeding-chips','Pick their feeding ritual ✦'); if (!txt('pet-treats')) return failInput('pet-treats','Their treat of choice — their fuel ✦'); if (!data.activities || data.activities.length === 0) return failChips('activity-chips','Pick what they actually do all day ✦'); if (!data.sleep) return failChips('sleep-chips','Where do they sleep? ✦'); if (!txt('pet-quirks')) return failInput('pet-quirks','Anything our chef should know? ✦'); }
    if (step === 5) { if (!txt('city')) return failInput('city','Which city do they rule? ✦'); if (!data.home) return failChips('home-chips','What kind of kingdom? ✦'); if (!data.squad || data.squad.length === 0) return failChips('squad-chips','Pick their squad — even "only child" counts ✦'); if (!data.humans) return failChips('humans-chips',"Who's in the household? ✦"); if (!data.weekend || data.weekend.length === 0) return failChips('weekend-chips','Where do they go on weekends? ✦'); }
    if (step === 6) { if (!txt('pet-enemies')) return failInput('pet-enemies','Every hero needs a sworn enemy ✦'); if (!txt('pet-iconic')) return failInput('pet-iconic','Tell us their finest moment ✦'); if (!txt('pet-mishaps')) return failInput('pet-mishaps','One adventure gone wrong ✦'); if (!txt('pet-companions')) return failInput('pet-companions','Their sidekicks and supporting cast ✦'); }
    if (step === 7) {
      if (!data.vibe) { const el = document.getElementById('wizard-vibes'); shake(el); reveal(el); showWizardError('Pick the universe for the book ✦'); return false; }
    }
    if (step === 9) { if (!txt('pet-creative')) return failInput('pet-creative', 'Tell our story team the mission — a line is enough ✦'); }
    if (step === 8) { if (!txt('owner-name')) return failInput('owner-name','What should we call you, co-author? ✦'); const em = txt('owner-email'); if (!em.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) return failInput('owner-email','We need a valid email to send your preview ✦'); if (!data.occasion) return failChips('occasion-chips','Pick an occasion — even "just love" ✦'); }
    return true;
  }

  function saveStep(step) {
    if (step === 2) { data.name = document.getElementById('pet-name').value.trim(); data.breed = document.getElementById('pet-breed').value.trim(); data.age = document.getElementById('pet-age').value.trim(); data.color = document.getElementById('pet-color').value.trim(); }
    if (step === 3) { data.essence = document.getElementById('pet-essence').value.trim(); data.signature = document.getElementById('pet-signature').value.trim(); data.monologue = document.getElementById('pet-monologue').value.trim(); }
    if (step === 4) { data.treats = document.getElementById('pet-treats').value.trim(); data.quirks = document.getElementById('pet-quirks').value.trim(); }
    if (step === 5) { data.city = document.getElementById('city').value.trim(); const zipEl = document.getElementById('zip'); if (zipEl) data.zip = zipEl.value.trim(); }
    if (step === 6) { data.enemies = document.getElementById('pet-enemies').value.trim(); data.iconic = document.getElementById('pet-iconic').value.trim(); data.mishaps = document.getElementById('pet-mishaps').value.trim(); data.companions = document.getElementById('pet-companions').value.trim(); const oneThing = document.getElementById('pet-one-thing'); if (oneThing) data.oneThingToKnow = oneThing.value.trim(); }
    if (step === 9) { data.creativeDirection = document.getElementById('pet-creative').value.trim(); const oneThing = document.getElementById('pet-one-thing'); if (oneThing) data.oneThingToKnow = oneThing.value.trim(); }
    if (step === 8) { data.ownerName = document.getElementById('owner-name').value.trim(); data.ownerEmail = document.getElementById('owner-email').value.trim(); }
  }

  // ── Submission helpers (hardened) ──────────────────────────────
  const WORKER_URL  = 'https://api.thepetails.com';
  // (Sheets webhook is now fired server-side by the Worker in save_meta — no browser call.)

  let submissionId = null;
  function getSubmissionId() {
    if (!submissionId) {
      const ts = Math.floor(Date.now() / 1000).toString();
      const rand = Math.random().toString(36).substring(2, 6);
      submissionId = 'sub_' + ts + '_' + rand;
    }
    return submissionId;
  }

  function buildFormData(photoUrls) {
    return {
      ownerName: data.ownerName||'', ownerEmail: data.ownerEmail||'', occasion: data.occasion||'', source: data.source||'', newsletter: data.newsletter||false,
      vibe: ({comic:'Comic Caper',storybook:'Storybook Magic',movie:'Cinema Poster',heritage:'Heritage Edition',pixar:'Pixar Magic'})[data.vibe]||data.vibe||'',
      name: data.name||'', species: data.species||'', breed: data.breed||'', age: data.age||'', weight: data.weight||'', color: data.color||'', gender: data.gender||'',
      energy: data.energy||'', social: data.social||'', traits: data.traits||[], essence: data.essence||'', signature: data.signature||'', monologue: data.monologue||'',
      feeding: data.feeding||'', treats: data.treats||'', activities: data.activities||[], sleep: data.sleep||'', quirks: data.quirks||'',
      city: data.city||'', zip: data.zip||'', home: data.home||'', squad: data.squad||[], humans: data.humans||'', weekend: data.weekend||[],
      enemies: data.enemies||'', iconic: data.iconic||'', mishaps: data.mishaps||'', companions: data.companions||'', oneThingToKnow: data.oneThingToKnow||'',
      creativeDirection: data.creativeDirection||'', photoUrls: photoUrls, photoCount: photoUrls.length
    };
  }

  async function uploadPhotoWithRetry(photo, index, sid, attempts) {
    attempts = attempts || UPLOAD_ATTEMPTS;
    const base64 = photo.dataUrl.replace(/^data:[^;]+;base64,/, '');
    const mimeType = (photo.dataUrl.match(/data:([^;]+);base64,/) || [])[1] || 'image/jpeg';
    for (let a = 1; a <= attempts; a++) {
      try {
        const res = await fetchWithTimeout(WORKER_URL, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', 'X-Petails-Secret': 'pbrw_p0CnDv3HszyoqbV8B6YkAopR8VUCWHqg' },
          body: JSON.stringify({ action: 'upload_photo', submissionId: sid, base64, mimeType, photoIndex: index })
        }, UPLOAD_TIMEOUT_MS);
        const result = await res.json();
        if (result && result.success && result.url) return result.url;
        console.warn('⚠️ photo_' + (index + 1) + ' attempt ' + a + ' rejected:', result && result.error);
      } catch (err) {
        console.warn('⚠️ photo_' + (index + 1) + ' attempt ' + a + (err && err.name === 'AbortError' ? ' timed out' : ' error'), err);
      }
      if (a < attempts) await new Promise(r => setTimeout(r, Math.min(5000, 800 * a))); // backoff
    }
    return null;
  }

  // Uploads every pending photo IN PARALLEL (shorter wait = less chance of abandoning),
  // each independently retried with its own timeout. Updates the progress bar live.
  async function uploadAllPhotos(sid) {
    const total = data.photos.length;
    let done = data.photos.filter(p => p.uploadedUrl).length;
    upProgress(done, total);
    await Promise.all(data.photos.map(async (photo, i) => {
      if (photo.uploadedUrl) return;             // already in R2 from a prior attempt — skip
      const url = await uploadPhotoWithRetry(photo, i, sid);
      if (url) {
        photo.uploadedUrl = url;
        done++;
        upProgress(done, total);
        upStatus('Uploading your photos… ' + done + ' of ' + total + ' done.');
        console.log('✅ photo_' + String(i + 1).padStart(2, '0') + ' →', url);
      }
    }));
    return data.photos.filter(p => p.uploadedUrl).map(p => p.uploadedUrl);
  }

  // Writes meta.json to R2 (durable record) and asks the Worker to notify Sheets.
  // Retried with a timeout; if the Sheet mirror lags we retry to push the row, but the
  // submission is considered safe the moment meta.json is stored in R2.
  async function saveMeta(sid, formData, attempts) {
    attempts = attempts || META_ATTEMPTS;
    for (let a = 1; a <= attempts; a++) {
      try {
        const res = await fetchWithTimeout(WORKER_URL, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', 'X-Petails-Secret': 'pbrw_p0CnDv3HszyoqbV8B6YkAopR8VUCWHqg' },
          body: JSON.stringify({ action: 'save_meta', submissionId: sid, formData, notifySheets: true })
        }, META_TIMEOUT_MS);
        const result = await res.json();
        if (result && result.success) {
          if (result.notified) return { ok: true, notified: true };
          // meta.json saved but Sheet mirror didn't confirm — retry to push the row.
          if (a < attempts) { await new Promise(r => setTimeout(r, Math.min(5000, 800 * a))); continue; }
          return { ok: true, notified: false };  // safe: record lives in R2, Sheet can be reconciled
        }
        console.warn('⚠️ save_meta attempt ' + a + ' rejected:', result && result.error);
      } catch (err) {
        console.warn('⚠️ save_meta attempt ' + a + (err && err.name === 'AbortError' ? ' timed out' : ' error'), err);
      }
      if (a < attempts) await new Promise(r => setTimeout(r, Math.min(5000, 800 * a)));
    }
    return { ok: false, notified: false };
  }

  // ok:true ONLY when every photo is confirmed in R2 AND meta.json is saved.
  async function finalizeSubmission() {
    if (!data.photos || data.photos.length === 0) return { ok: false, reason: 'no-photos' };
    const sid = getSubmissionId();
    const total = data.photos.length;

    upStatus('Uploading your photos… keep this page open.');
    const r2Urls = await uploadAllPhotos(sid);
    if (r2Urls.length < total) {
      return { ok: false, reason: 'upload-incomplete', uploaded: r2Urls.length, total: total };
    }

    upStatus('Saving your story…');
    upProgress(total, total);
    const formData = buildFormData(r2Urls);
    const meta = await saveMeta(sid, formData);
    if (!meta.ok) return { ok: false, reason: 'meta-failed' };

    console.log('🐾 save_meta ok · sheets notified:', meta.notified);
    return { ok: true, photoCount: r2Urls.length, notified: meta.notified };
  }

  function setupSingleChips(containerId, dataKey) {
    document.querySelectorAll(`#${containerId} .chip`).forEach(chip => {
      chip.addEventListener('click', () => { document.querySelectorAll(`#${containerId} .chip`).forEach(c => c.classList.remove('active')); chip.classList.add('active'); data[dataKey] = chip.dataset.val; clearWizardError(); saveProgress(); });
    });
  }
  setupSingleChips('species-chips','species'); setupSingleChips('weight-chips','weight'); setupSingleChips('energy-chips','energy');
  setupSingleChips('social-chips','social'); setupSingleChips('feeding-chips','feeding'); setupSingleChips('sleep-chips','sleep');
  setupSingleChips('home-chips','home'); setupSingleChips('humans-chips','humans'); setupSingleChips('occasion-chips','occasion'); setupSingleChips('source-chips','source');

  document.querySelectorAll('[data-group="gender"]').forEach(chip => {
    chip.addEventListener('click', () => { document.querySelectorAll('[data-group="gender"]').forEach(c => c.classList.remove('active')); chip.classList.add('active'); data.gender = chip.dataset.val; clearWizardError(); saveProgress(); });
  });

  function setupMultiChips(containerId, dataKey) {
    document.querySelectorAll(`#${containerId} .chip`).forEach(chip => {
      chip.addEventListener('click', () => { chip.classList.toggle('active'); const v = chip.dataset.val; if (chip.classList.contains('active')) data[dataKey].push(v); else data[dataKey] = data[dataKey].filter(x => x !== v); clearWizardError(); saveProgress(); });
    });
  }
  setupMultiChips('traits-chips','traits'); setupMultiChips('activity-chips','activities'); setupMultiChips('squad-chips','squad'); setupMultiChips('weekend-chips','weekend');

  // Creative-direction starters: tap prellena el textarea (editable)
  document.querySelectorAll('#creative-chips .chip').forEach(chip => {
    chip.addEventListener('click', () => {
      document.querySelectorAll('#creative-chips .chip').forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      const ta = document.getElementById('pet-creative');
      ta.value = chip.dataset.fill;
      data.creativeDirection = ta.value;
      clearWizardError(); saveProgress();
    });
  });

  document.getElementById('news-check').parentElement.addEventListener('click', (e) => {
    e.preventDefault();
    const ck = document.getElementById('news-check');
    ck.classList.toggle('on');
    data.newsletter = ck.classList.contains('on');
    saveProgress();
  });

  // ── Photo decoding + compression (hardened, cross-browser) ─────
  // HEIC/HEIF (iPhone default) can't be decoded by <img> outside Safari,
  // so we lazy-load heic2any and convert to JPEG first.
  let _heicLibPromise = null;
  function loadHeicLib() {
    if (window.heic2any) return Promise.resolve(window.heic2any);
    if (_heicLibPromise) return _heicLibPromise;
    _heicLibPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      s.async = true;
      s.onload = () => resolve(window.heic2any);
      s.onerror = () => reject(new Error('heic-lib-failed'));
      document.head.appendChild(s);
    });
    return _heicLibPromise;
  }

  function isHeic(file) {
    const t = (file.type || '').toLowerCase();
    const n = (file.name || '').toLowerCase();
    return t.indexOf('heic') !== -1 || t.indexOf('heif') !== -1 || /\.(heic|heif)$/.test(n);
  }

  // Lee la orientación EXIF (1–8) directo de los bytes del JPEG. A prueba de navegador:
  // no dependemos de que el browser auto-rote. Si no es JPEG o no tiene el tag → 1 (sin rotar).
  async function getExifOrientation(blob) {
    try {
      const buf = await blob.slice(0, 256 * 1024).arrayBuffer();
      const view = new DataView(buf);
      if (view.byteLength < 4 || view.getUint16(0, false) !== 0xFFD8) return 1; // no es JPEG
      let offset = 2;
      while (offset + 4 <= view.byteLength) {
        const marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFDA || marker === 0xFFD9) break;          // SOS / EOI → fin
        if ((marker & 0xFF00) !== 0xFF00) break;                    // no es marker → fin
        const segLen = view.getUint16(offset, false);
        if (marker === 0xFFE1) {                                    // APP1 (Exif)
          const exifStart = offset + 2;
          if (view.getUint32(exifStart, false) === 0x45786966) {    // "Exif"
            const tiff = exifStart + 6;                             // saltea "Exif\0\0"
            const little = view.getUint16(tiff, false) === 0x4949;  // 'II' = little-endian
            const g16 = (o) => view.getUint16(o, little);
            const g32 = (o) => view.getUint32(o, little);
            const ifd0 = tiff + g32(tiff + 4);
            const entries = g16(ifd0);
            for (let i = 0; i < entries; i++) {
              const entry = ifd0 + 2 + i * 12;
              if (g16(entry) === 0x0112) {                          // tag Orientation
                const v = g16(entry + 8);
                return (v >= 1 && v <= 8) ? v : 1;
              }
            }
          }
        }
        offset += segLen;                                           // saltea al próximo marker
      }
      return 1;
    } catch (e) { return 1; }
  }

  // Decodifica a píxeles CRUDOS (sin auto-orientar) para que NOSOTROS controlemos la rotación.
  // Pedir imageOrientation:'none' fuerza crudo en navegadores modernos; los viejos ya dan crudo.
  async function decodeRaw(blob) {
    if ('createImageBitmap' in window) {
      try { return await createImageBitmap(blob, { imageOrientation: 'none' }); } catch (e) {}
    }
    return await new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      const img = new Image();
      try { img.style.imageOrientation = 'none'; } catch (e) {}
      img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode-failed')); };
      img.src = url;
    });
  }

  // Decodifica dejando que el navegador aplique la orientación EXIF (default moderno).
  async function decodeOriented(blob) {
    if ('createImageBitmap' in window) {
      try { return await createImageBitmap(blob); } catch (e) {}
    }
    return await new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode-failed')); };
      img.src = url;
    });
  }

  // Aplica la transformación EXIF al contexto del canvas. w/h = dimensiones dibujadas (escaladas).
  function applyExifTransform(ctx, orientation, w, h) {
    switch (orientation) {
      case 2: ctx.transform(-1, 0, 0, 1, w, 0); break;             // espejo horizontal
      case 3: ctx.transform(-1, 0, 0, -1, w, h); break;            // 180°
      case 4: ctx.transform(1, 0, 0, -1, 0, h); break;             // espejo vertical
      case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;              // transpuesta
      case 6: ctx.transform(0, 1, -1, 0, h, 0); break;             // 90° CW  (vertical iPhone)
      case 7: ctx.transform(0, -1, -1, 0, h, w); break;            // transversa
      case 8: ctx.transform(0, -1, 1, 0, 0, w); break;             // 90° CCW
      default: break;                                              // 1 = sin cambios
    }
  }

  async function normalizePhoto(file) {
    const MAX_EDGE = 2048;
    const TARGET_BYTES = 1600000; // ~1.6MB cap on the base64 payload per photo
    try {
      let blob = file;
      if (isHeic(file)) {
        const heic2any = await loadHeicLib();
        let out = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 });
        blob = Array.isArray(out) ? out[0] : out;
      }

      // El navegador ya auto-orienta según EXIF (Safari 13.4+, Chrome 81+): decodificamos
      // orientado y NO aplicamos transformación manual (evita la doble rotación).
      const orientation = 1;
      const bmp = await decodeOriented(blob);
      let rw = bmp.naturalWidth || bmp.width;
      let rh = bmp.naturalHeight || bmp.height;
      if (!rw || !rh) throw new Error('zero-dimensions');

      // Escalamos la imagen cruda al lado más largo = MAX_EDGE.
      let sw = rw, sh = rh;
      if (Math.max(rw, rh) > MAX_EDGE) { const s = MAX_EDGE / Math.max(rw, rh); sw = Math.round(rw * s); sh = Math.round(rh * s); }

      // En rotaciones de 90°/270° las dimensiones del canvas se intercambian.
      const swap = orientation >= 5 && orientation <= 8;
      const canvas = document.createElement('canvas');
      canvas.width  = swap ? sh : sw;
      canvas.height = swap ? sw : sh;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';                 // aplana transparencia para JPEG
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      applyExifTransform(ctx, orientation, sw, sh);
      ctx.drawImage(bmp, 0, 0, sw, sh);
      if (bmp.close) { try { bmp.close(); } catch (e) {} }   // libera memoria del ImageBitmap

      let q = 0.9;
      let dataUrl = canvas.toDataURL('image/jpeg', q);
      while (dataUrl.length > TARGET_BYTES && q > 0.5) { q -= 0.1; dataUrl = canvas.toDataURL('image/jpeg', q); }
      return (dataUrl && dataUrl.length > 1000) ? dataUrl : null;
    } catch (e) {
      console.warn('normalizePhoto failed:', file && file.name, e);
      return null;
    }
  }

  function updatePhotosCount() {
    const el = document.getElementById('photos-count');
    if (!el) return;
    const n = data.photos.length;
    if (n > 0) { el.textContent = n + ' photo' + (n > 1 ? 's' : '') + ' ready · up to 5'; el.classList.remove('hidden'); }
    else { el.classList.add('hidden'); el.textContent = ''; }
  }

  const IMAGE_EXT_RE = /\.(jpe?g|png|webp|gif|bmp|heic|heif|avif|tiff?)$/i;
  function looksLikeImage(file) {
    if (file.type && file.type.indexOf('image/') === 0) return true;
    if (isHeic(file)) return true;
    return IMAGE_EXT_RE.test(file.name || '');   // some browsers report empty type for HEIC/TIFF
  }

  async function handleFiles(files) {
    clearWizardError();
    const preview = document.getElementById('photos-preview');
    const remaining = 5 - data.photos.length;
    if (remaining <= 0) { showWizardError('You already have 5 photos — the max. Remove one to add another. ✦'); return; }
    const list = [...files].slice(0, remaining);
    let failed = 0, heicSeen = false;
    for (const file of list) {
      if (!looksLikeImage(file)) { failed++; continue; }
      if (isHeic(file)) heicSeen = true;
      const dataUrl = await normalizePhoto(file);
      if (!dataUrl) { failed++; continue; }
      const uid = (file.name || 'photo') + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6);
      const wrap = document.createElement('div');
      wrap.className = 'relative';
      wrap.innerHTML = `<img src="${dataUrl}" class="photo-thumb"><button class="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[var(--ink)] text-[var(--paper)] text-xs border-2 border-[var(--paper)] flex items-center justify-center" type="button">×</button>`;
      wrap.querySelector('button').onclick = () => { wrap.remove(); data.photos = data.photos.filter(p => p.id !== uid); updatePhotosCount(); };
      preview.appendChild(wrap);
      data.photos.push({ id: uid, name: file.name || 'photo.jpg', size: dataUrl.length, dataUrl: dataUrl, uploadedUrl: null });
    }
    updatePhotosCount();
    if (failed > 0) {
      showWizardError(heicSeen
        ? 'We couldn’t process one or more photos. If they’re iPhone HEIC files and conversion failed, export them as JPG and try again. ✦'
        : 'We couldn’t process ' + failed + ' file(s). Use JPG, PNG, WEBP or HEIC. ✦');
    }
  }

  const zone = document.getElementById('upload-zone');
  ['dragenter','dragover'].forEach(ev => zone.addEventListener(ev, e => { e.preventDefault(); zone.classList.add('dragover'); }));
  ['dragleave','drop'].forEach(ev => zone.addEventListener(ev, e => { e.preventDefault(); zone.classList.remove('dragover'); }));
  zone.addEventListener('drop', e => handleFiles(e.dataTransfer.files));

  function selectVibe(card) {
    if (card.closest('#wizard')) return;
    document.querySelectorAll('.vibe-card[data-vibe]').forEach(c => { if (!c.closest('#wizard')) c.classList.remove('selected'); });
    card.classList.add('selected');
    var det = card.querySelector('.vibe-detail');
    if (det && !det.querySelector('.vibe-start')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vibe-start';
      b.style.cssText = 'display:block;width:100%;margin-top:10px;background:var(--pink);color:#fff;font-weight:700;font-size:13px;border:2px solid var(--ink);border-radius:999px;padding:10px 14px;cursor:pointer;';
      b.textContent = 'Build my book in this universe →';
      b.addEventListener('click', function(e){
        e.stopPropagation();
        startWithVibe(card.dataset.vibe);
      });
      det.appendChild(b);
    }
  }

  function startWithVibe(v) {
    data.vibe = v;
    document.querySelectorAll('#wizard-vibes .vibe-card').forEach(c => c.classList.toggle('selected', c.dataset.vibe === v));
    saveProgress();
    openWizard();
  }

  function pickVibeWizard(card) {
    document.querySelectorAll('#wizard-vibes .vibe-card').forEach(c => c.classList.remove('selected'));
    card.classList.add('selected');
    data.vibe = card.dataset.vibe;
    clearWizardError();
    saveProgress();
  }

  document.querySelectorAll('.step-input').forEach(el => {
    el.addEventListener('input', () => { clearWizardError(); saveStep(currentStep); saveProgress(); });
  });

  document.querySelectorAll('.step').forEach(s => s.classList.add('hidden'));

  // ── Hardcover quantity stepper ──
  // Pricing: $79 for first copy + $30 per extra copy
  // Cart uses two variants: one for the base ($79) + one for extras ($30 each)
  var hcQty = 1;
  var HC_BASE_VARIANT  = '51850659528989';   // $79 — first copy (existing)
  var HC_EXTRA_VARIANT = '51850919641373'; // $30 — Extra Hardcover Copy

  function getHCPrice(qty) {
    return 79 + (qty - 1) * 30;
  }

  function changeHCQty(delta) {
    hcQty = Math.max(1, hcQty + delta);
    document.getElementById('hc-qty-display').textContent = hcQty;
    document.getElementById('hc-price-display').textContent = '$' + getHCPrice(hcQty);
  }

  function buyHardcover() {
    var cartUrl;
    if (hcQty === 1) {
      // Just the base copy
      cartUrl = '/cart/' + HC_BASE_VARIANT + ':1';
    } else {
      // Base copy + extra copies at $30 each
      cartUrl = '/cart/' + HC_BASE_VARIANT + ':1,' + HC_EXTRA_VARIANT + ':' + (hcQty - 1);
    }
    selectProduct(cartUrl);
  }


  // ── Upgrade bridge ──
  // When the portal sends a customer here to upgrade a digital book to hardcover,
  // it lands as ?upgrade=<existing_submissionId>&v=<variant>. We add that variant
  // to the cart carrying the EXISTING submissionId (so the webhook upgrades the
  // right book) and go straight to checkout.
  (function () {
    if (window.__petailsUpgradeHandled) return;
    try {
      var params = new URLSearchParams(window.location.search);
      var up = params.get('upgrade');
      var v = params.get('v');
      if (up && v) {
        submissionId = up;            // force the existing book's id onto the line item
        goToCheckout('/cart/' + encodeURIComponent(v) + ':1');
      }
    } catch (e) { /* no-op */ }
  })();
